// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7af8c79","455":"f0776ce7","977":"22d78dad"}[chunkId] + ".chunk.js";
};